import { authenticatedPatch } from '../../../../../api/request';

export default async function saveUpdatedUser(userId, saveData, setErrorMessage) {
    const onFail = () => setErrorMessage('Ocurrió un error guardando la actualización de la cita.');
    const url = `/web-admin-data/update-profile/web-user/${userId}`;
    return await authenticatedPatch(url, onFail, saveData);
}
